<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container" v-loading="globalLoading">
      <div class="content">
        <el-row>

          <el-col :span="6" :xs="24">
            <div class="product-menu">
              <Menu
                :title="menuData.title"
                :lists="menuData.data"
                @on-click="onClickMenu"
              />
            </div>
          </el-col>

          <el-col :span="18" :xs="24">
            <div class="product-body">
              
              <div class="title">{{ menuData.data[menuIndex].text }}</div>

              <div class="search-wrap" v-if="menuType === 'number'">
                <div class="inp-box">
                  <div class="inp-text">
                    <input
                      v-model="sn"
                      type="text"
                      :placeholder="$t('tipSn')"
                      @keydown.enter="onAddSN"
                    />
                  </div>
                </div>
                <div class="btn-wrap">
                  <div class="btn-search" @click="onAddSN">
                    {{ $t("add") }}
                  </div>
                </div>
                <div class="btn-wrap" style="margin-left: 10px;">
                  <div class="btn-search" @click="onSearchSN">
                    {{ $t("search") }}
                  </div>
                </div>
              </div>


              <div class="table-wrap">
                <el-col :span="14" :xs="24">
                  <div class="section-wrap" v-if="menuType === 'info'">
                    <div class="icon">{{ $t("account") }}</div>
                    <div class="inp-box">{{ anselmUserInfo.username }}</div>
                  </div>
                  <div class="section-wrap" v-if="menuType === 'info'">
                    <div class="icon">{{ $t("phone") }}</div>
                    <div class="inp-box">{{ anselmUserInfo.mobile }}</div>
                    <div class="btn-wrap">
                      <div class="btn-search" @click="onEdit('mobile')">
                        {{ $t("edit") }}
                      </div>
                    </div>
                  </div>
                  <div class="section-wrap" v-if="menuType === 'info'">
                    <div class="icon">{{ $t("email") }}</div>
                    <div class="inp-box">{{ anselmUserInfo.email }}</div>
                    <div class="btn-wrap">
                      <div class="btn-search" @click="onEdit('email')">
                        {{ $t("edit") }}
                      </div>
                    </div>
                  </div>
                  <div class="section-wrap" v-if="menuType === 'info'">
                    <div class="icon">{{ $t("password") }}</div>
                    <div class="inp-box">******</div>
                    <div class="btn-wrap">
                      <div class="btn-search" @click="onEdit('pwd')">
                        {{ $t("edit") }}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-table
                  v-if="menuType === 'sellOrder'"
                  :data="sellOrderData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column
                    prop="date"
                    :label="$t('dates')"
                    width="100"
                  />
                  <el-table-column prop="address" :label="$t('infos')" />
                  <el-table-column prop="price" :label="$t('price')" />
                </el-table>
                <el-table
                  v-if="menuType === 'serviceOrder'"
                  :data="sellOrderData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column
                    prop="date"
                    :label="$t('dates')"
                    width="100"
                  />
                  <el-table-column prop="address" :label="$t('infos')" />
                  <el-table-column prop="price" :label="$t('price')" />
                </el-table>
                <el-table
                  v-if="menuType === 'order'"
                  :data="userSoftOrderData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column :label="$t('dates')" width="100">
                    <template slot-scope="scope">
                      <span class="cursor">
                        {{ scope.row.createtime | timeFormatDate }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deviceNumber')">
                    <template slot-scope="scope">
                      <span class="cursor">
                        {{ scope.row.sn }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="status_text"
                    :label="$t('payStatus')"
                  />
                  <el-table-column prop="amount" :label="$t('price')" />
                </el-table>
                <el-table
                  v-if="menuType === 'watch'"
                  :data="sellOrderData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column
                    prop="date"
                    :label="$t('dates')"
                    width="180"
                  />
                  <el-table-column prop="address" :label="$t('infos')" />
                  <el-table-column prop="price" :label="$t('price')" />
                </el-table>
                <el-table
                  v-if="menuType === 'number'"
                  :data="userSNData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <el-table-column :label="$t('infos')">
                    <template slot-scope="scope">
                      <span class="cursor">
                        {{ scope.row.sn }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('edits')">
                    <template slot-scope="scope">
                      <span
                        class="cursor"
                        @click="onSoftorderCreate(scope.row)"
                      >
                        {{ $t("upgradeImmediately") }}
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  class="pagination"
                  v-if="userSNData.length || userSoftOrderData.length"
                >
                  <el-pagination
                    layout="prev, pager, next"
                    :total="totalPage"
                    @current-change="onChangePage"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      :title="
        /^mobile$/.test(formType)
          ? $t('changeTheTel')
          : /^pwd$/.test(formType)
          ? $t('changeThePassword')
          : $t('changeTheEmail')
      "
      :visible.sync="dialogFormVisible"
      fullscreen
      destroy-on-close
      :close-on-click-modal="false"
    >
      <el-form
        :model="
          /^mobile$/.test(formType)
            ? formMobile
            : /^pwd$/.test(formType)
            ? formPwd
            : formEmail
        "
        v-loading="loading"
      >
        <el-form-item
          :label="/^mobile$/.test(formType) ? $t('oldPhone') : $t('phone')"
          :label-width="formLabelWidth"
        >
          {{ anselmUserInfo.mobile }}
        </el-form-item>
        <el-form-item
          v-if="/^email$/.test(formType)"
          :label="$t('oldEmail')"
          :label-width="formLabelWidth"
        >
          {{ anselmUserInfo.email }}
        </el-form-item>
        <el-form-item
          v-if="/^mobile$/.test(formType)"
          :label="$t('newPhone')"
          :label-width="formLabelWidth"
        >
          <el-input v-model="formMobile.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-if="/^email$/.test(formType)"
          :label="$t('emailNew')"
          :label-width="formLabelWidth"
        >
          <el-input v-model="formEmail.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-if="/^pwd$/.test(formType)"
          :label="$t('newPassword')"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="formPwd.newpassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('code')" :label-width="formLabelWidth">
          <el-input v-model="captcha" autocomplete="off">
            <template slot="append">
              <a href="javascript:;" @click="onGetCode">
                {{
                  resetPwdCodeTime === 60
                    ? $t("getCode")
                    : resetPwdCodeTime + "s"
                }}
              </a>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit(formType)">{{
          $t("submit")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      tle="升级"
      :visible.sync="qcVisible"
      fullscreen
      destroy-on-close
      :close-on-click-modal="false"
      @closed="onQcClosed"
    >
      <a
        class="download-box"
        :href="downloadPath"
        target="_blank"
        @click="onDownloadPath"
        v-if="downloadPath !== ''"
        >{{ $t("downloads") }}</a
      >
      <div class="payinfo-wrap" v-if="downloadPath === '' && payinfo.length">
        <h2>
          {{ $t("paymentMethod") }}
          <span>{{ $t("amount") }}：{{ upgradableData.amount }}</span>
        </h2>
        <div class="payinfo">
          <div class="pay-item" v-for="(v, i) in payinfo" :key="i">
            <div class="pay">
              <img :src="v.pay" alt="" />
            </div>
            <div class="text">
              <img :src="v.icon" alt="" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Lstore from "store";
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";
import Menu from "@c/Menu";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      src: require("@a/img/banner-user.png"),
      menuIndex: 0,
      menuType: "info",
      menuData: {
        title: this.$t("userCenter"),
        data: [
          {
            value: "info",
            text: this.$t("myProfile")
          },
          // {
          //   value: "sellOrder",
          //   text: "购买记录"
          // },
          // {
          //   value: "serviceOrder",
          //   text: "维修记录"
          // },
          {
            value: "order",
            text: this.$t("myOrders")
          },
          // {
          //   value: "watch",
          //   text: "万用表"
          // },
          {
            value: "number",
            text: this.$t("mySN")
          }
        ]
      },
      sellOrderData: [],
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      formMobile: {
        mobile: ""
      },
      formEmail: {
        email: ""
      },
      formPwd: {
        newpassword: "",
        type: "mobile"
      },
      captcha: "",
      resetPwdCodeTime: 60,
      formType: "mobile",
      userSNData: [],
      userSNParam: {
        page: 1,
        limit: 100,
        order: "DESC"
      },
      totalPage: 0,
      sn: "",
      payinfo: [],
      downloadPath: "",
      timeout: null,
      qcVisible: false,
      userSoftOrderData: [],
      upgradableData: {
        amount: 0
      },
      swiperImgs: [],
      loading: false,
      globalLoading: false
    };
  },
  components: {
    Swiper,
    Menu
  },
  computed: {
    ...mapState(["anselmUserInfo"])
  },
  created() {
    this.topingAll();
    this.productCat();
    if (/^number$/.test(this.$route.query.type)) {
      this.$set(this, "menuType", this.$route.query.type);
      this.$set(this, "menuIndex", 2);
      this.userSN({
        ...this.userSNParam,
        token: this.anselmUserInfo.token
      });
    }
  },
  methods: {
    ...mapMutations(["USER_INFO", "IS_LOGIN","PRODUCT_DATA"]),
    productCat(params) {
            API.productCat(params).then(res => {
            if (/^(1)$/.test(res.code)) {
            this.PRODUCT_DATA(res.data);
            LStore.set("productData", res.data);
            } else {
            this.$message.error(res.msg);
            }
        });
        },
    topingAll(params) {
      API.topingAll(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter((v) => Number(v.typelist) === 8)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    logout(params) {
      API.logout(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.IS_LOGIN(false);
          this.USER_INFO(null);
          Lstore.remove("anselmUserInfo");
          this.$router.push({ path: "login" });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    smsSend(params) {
      API.smsSend(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
            onClose: () => {
              this.handleCode();
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    changemobile(params) {
      this.$set(this, "loading", true);
      API.changemobile(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 2000,
            onClose: () => {
              let userInfo = {
                ...this.anselmUserInfo,
                mobile: this.formMobile.mobile
              };
              this.USER_INFO(userInfo);
              Lstore.set("anselmUserInfo", userInfo);
              this.resetForm();
            }
          });

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    changeemail(params) {
      this.$set(this, "loading", true);
      API.changeemail(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 2000,
            onClose: () => {
              let userInfo = {
                ...this.anselmUserInfo,
                email: this.formMobile.email
              };
              Lstore.set("anselmUserInfo", userInfo);
              this.USER_INFO(userInfo);
              this.resetForm();
            }
          });

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetpwd(params) {
      this.$set(this, "loading", true);
      API.resetpwd(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 2000,
            onClose: () => {
              this.logout({
                token: this.anselmUserInfo.token
              });
              this.resetForm();
            }
          });

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onClickMenu(v) {
      this.$set(this, "userSoftOrderData", []);
      this.$set(this, "userSNData", []);
      this.$set(this, "menuType", v.data.value);
      this.$set(this, "menuIndex", v.index);

      this.$set(this.userSNParam, "page", 1);
      this.$set(this, "totalPage", 0);
      this.$set(this.userSNParam, "cat", this.$route.query.cat);

      console.log(v);
      switch (v.data.value) {
        case "number":
          this.$set(this, "downloadPath", "");
          this.userSN({
            ...this.userSNParam,
            token: this.anselmUserInfo.token
          });
          break;
        case "order":
          this.userSoftOrder({
            ...this.userSNParam,
            token: this.anselmUserInfo.token
          });
          break;
      }
    },
    handleCode() {
      this.timeout = setInterval(() => {
        this.resetPwdCodeTime--;
        if (this.resetPwdCodeTime <= 0) {
          clearInterval(this.timeout);
          this.$set(this, "resetPwdCodeTime", 60);
        }
      }, 1000);
    },
    onEdit(type) {
      this.$set(this, "formType", type);
      this.$set(this, "dialogFormVisible", true);
    },
    onGetCode() {
      this.smsSend({ mobile: this.anselmUserInfo.mobile, event: "resetpwd" });
    },
    resetForm() {
      this.$set(this.formMobile, "mobile", "");
      this.$set(this.formEmail, "email", "");
      this.$set(this.formPwd, "newpassword", "");
      this.$set(this, "captcha", "");
    },
    onSubmit(formType) {
      switch (formType) {
        case "mobile":
          this.changemobile({
            ...this.formMobile,
            token: this.anselmUserInfo.token,
            captcha: this.captcha
          });
          break;
        case "pwd":
          this.resetpwd({
            ...this.formPwd,
            mobile: this.anselmUserInfo.mobile,
            token: this.anselmUserInfo.token,
            captcha: this.captcha
          });
          break;
        case "email":
          this.changeemail({
            ...this.formEmail,
            token: this.anselmUserInfo.token,
            captcha: this.captcha
          });
          break;
        default:
          this.$set(this, "dialogFormVisible", false);
      }
    },
    userSN(params) {
      this.$set(this, "loading", true);
      API.userSN(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "userSNData", res.data.rows);
          this.$set(this, "totalPage", res.data.total);

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addSN(params) {
      API.addSN(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$message.success(res.msg || "添加成功！");
          this.$set(this.userSNParam, "page", 1);
          this.userSN({
            ...this.userSNParam,
            token: this.anselmUserInfo.token
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onAddSN() {
      if (this.sn !== "") {
        this.addSN({
          sn: this.sn,
          token: this.anselmUserInfo.token
        });
      } else {
        this.$message.error("请输入设备序列号");
      }
    },
    searchSN(params) {
      this.$set(this, "loading", true);
      API.searchSN(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "userSNData", res.data.rows);
          this.$set(this, "totalPage", res.data.total);

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSearchSN() {
      if (this.sn !== "") {
        this.searchSN({
          searchSn: this.sn,
          token: this.anselmUserInfo.token,
          page: this.userSNParam.page,
          limit: this.userSNParam.limit,
          order: this.userSNParam.order
        });
      } else {
        this.$message.error("请输入设备序列号");
      }
    },
    upgradable(params) {
      this.$set(this, "globalLoading", true);
      API.upgradable(params).then((res) => {
        this.$set(this, "globalLoading", false);
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "qcVisible", true);
          let orderno = "";
          this.$set(this, "upgradableData", res.data);
          if (res.msg.payinfo !== undefined) {
            this.$set(this, "payinfo", res.msg.payinfo);
            orderno = res.msg.orderno;
          }
          if (res.data !== null && res.data.payinfo !== undefined) {
            this.$set(this, "payinfo", res.data.payinfo);
            orderno = res.data.orderno;
          }
          // this.softorderOrderpay({
          //   type: "wx",
          //   token: this.anselmUserInfo.token,
          //   userid: this.anselmUserInfo.user_id,
          //   orderno: orderno
          // });
          this.handleSoftorderCheckOrder({
            token: this.anselmUserInfo.token,
            userid: this.anselmUserInfo.user_id,
            orderno: orderno
          });
        } else if (/^(6666)$/.test(res.code)) {
          this.$set(this, "qcVisible", true);
          this.$set(this, "downloadPath", res.data.downloadPath);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softorderOrderpay(params) {
      API.softorderOrderpay(params).then((res) => {
        if (/^(1|8888)$/.test(res.code)) {
          this.$set(this, "downloadPath", res.data.downloadPath);

          this.handleSoftorderCheckOrder(params);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softorderCheckOrder(params) {
      API.softorderCheckOrder(params).then((res) => {
        if (/^(1|8888)$/.test(res.code)) {
          this.$set(this, "downloadPath", res.data.downloadPath);
          clearInterval(this.timeout);
        } else {
          // this.$message.error(res.msg);
        }
      });
    },
    userSoftOrder(params) {
      this.$set(this, "loading", true);
      API.userSoftOrder(params).then((res) => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "userSoftOrderData", res.data.rows);

          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSoftorderCheckOrder(params) {
      clearInterval(this.timeout);
      this.timeout = setInterval(() => {
        this.softorderCheckOrder(params);
      }, 3000);
    },
    onDownloadPath() {
      //window.open(this.downloadPath);
    },
    onSoftorderCreate(res) {
      this.$set(this, "downloadPath", "");
      this.upgradable({
        token: this.anselmUserInfo.token,
        userid: this.anselmUserInfo.user_id,
        sn: res.sn
      });
    },
    onChangePage(v) {
      this.$set(this.userSNParam, "page", v);
      this.userSN({
        ...this.userSNParam,
        token: this.anselmUserInfo.token
      });
    },
    onQcClosed() {
      clearInterval(this.timeout);
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  margin-bottom: 40px;
}
.section-wrap {
  display: flex;
  align-items: center;
  flex-direction: row;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  input {
    font-size: 20px;
    width: 100%;
    background: none;
    border: none;
  }

  .icon {
    width: 50px;
  }

  .inp-box {
    flex-basis: 85%;
    padding: 0 10px;

    .inp-text {
      border-bottom: 1px solid var(--color-line-light);
    }
  }

  .btn-wrap {
    flex-basis: 15%;
  }

  .btn-search {
    padding: 10px;
    text-align: center;
    color: var(--color-green);
    cursor: pointer;
  }
}
.product-menu {
  margin-top: 40px;
  padding-right: 80px;
}
.product-body {
  margin: 20px 0;

  .title {
    display: flex;
    height: 100px;
    align-items: center;
    font-size: 24px;
    color: var(--color-light-black);
    font-weight: bold;
  }
}

.dialog-footer {
  text-align: center;
}

.search-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  input {
    font-size: 20px;
    width: 100%;
    background: none;
    border: none;
  }

  .icon-search {
    width: 31px;
  }

  .inp-box {
    flex-basis: 80%;
    padding: 0 10px;

    .inp-text {
      border-bottom: 1px solid var(--color-black);
    }
  }

  .btn-wrap {
    flex-basis: 15%;
  }

  .btn-search {
    cursor: pointer;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    color: var(--color-white);
    border-radius: 5px;
    background: var(--color-green);
  }
}

.payinfo-wrap {
  h2 {
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    span {
      margin-left: 20px;
      color: red;
    }
  }
}

.payinfo {
  margin-top: 40px;
  text-align: center;
  h2 {
    font-weight: bold;
  }
  .pay-item {
    display: inline-block;
    text-align: center;
  }
}

@media only screen and (max-width: 767px) {
  .product-menu {
    padding: 0;
  }
}
</style>
